import colors from "../../../styles/colors"
import fonts from "../../../styles/fonts"

const ButtonStyle = `
  cursor: pointer;
  padding: 16px 40px;
  box-sizing: border-box;
  display: inline-block;
  text-align: center;
  ${fonts.openSans};
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-decoration: none;
  text-transform: uppercase;
  transition: all 0.5s;
  outline: none;
`

const newButtonStyle = `
  cursor: pointer;
  padding: 16px 40px;
  box-sizing: border-box;
  display: inline-block;
  text-align: center;
  ${fonts.ttNormsProRegular};
  font-size: 13px;
  line-height: 18px;
  text-decoration: none;
  transition: all 0.5s;
  outline: none;
  font-weight: 400;
  letter-spacing: 0px;
  width: 100%;
  max-width: 460px;
`

const ButtonStyleWhite = `
  ${ButtonStyle}
  border: 1px solid ${colors.black};
  color: ${colors.black};
  background: ${colors.white};

  &:hover,
  &:active,
  &:focus {
    background: ${colors.black};
    color: ${colors.white};
  }
`

const ButtonStyleBeige = `
  ${ButtonStyle}
  border: 1px solid ${colors.secondaryBeige};
  color: ${colors.white};
  background: ${colors.secondaryBeige};

  &:hover,
  &:active,
  &:focus {
    border: 1px solid ${colors.green};
    background: ${colors.green};
  }
`

const ButtonStyleBeigeBorder = `
  ${newButtonStyle}
  border: 1px solid ${colors.black};
  color: ${colors.black};
  background: ${colors.newbeige};

  &:hover,
  &:active,
  &:focus {
    border: 1px solid ${colors.green};
    background: ${colors.green};
    color: ${colors.white};
  }
`

const ButtonStyleGreen = `
  ${ButtonStyle}
  border: 1px solid ${colors.newgreen};
  color: ${colors.white};
  background: ${colors.newgreen};
  
  &:hover,
  &:active,
  &:focus {
    background: ${colors.white};
    color: ${colors.newgreen};
  }
`

const ButtonStyleDarkGreen = `
  ${newButtonStyle}
  border: 1px solid ${colors.darkergreen};
  color: ${colors.white};
  background: ${colors.darkergreen};
  
  &:hover,
  &:active,
  &:focus {
    background: ${colors.white};
    color: ${colors.darkergreen};
  }
`

const ButtonStyleGreenDisabled = `
  ${ButtonStyle}
  border: 1px solid ${colors.newgreen};
  color: ${colors.white};
  background: ${colors.newgreen};
  cursor: default;
`

const ButtonStyleLightGreen = `
  ${ButtonStyle}
  border: 1px solid ${colors.black};
  color: ${colors.trueBlack};
  background: ${colors.newbeige};
  
  &:hover,
  &:active,
  &:focus {
    background: ${colors.newbeige};
    color: ${colors.trueBlack};
  }
`

const ButtonStyleTransparent = `
  ${ButtonStyle}
  border: 1px solid ${colors.white};
  color: ${colors.white};
  background: "transparent";
  
  &:hover,
  &:active,
  &:focus {
    border: 1px solid ${colors.lightGreen};
    color: ${colors.white};
    background: ${colors.lightGreen};
  }
`

const TextLinkStyle = `
  box-sizing: border-box;
  display: inline-block;
  ${fonts.helveticaNeueCondensedBold};
  font-size: 12px;
  letter-spacing: 0.86px;
  line-height: 14px;
  color: ${colors.black};
  text-transform: uppercase;
  transition: all 0.5s;
  text-decoration: none;
  padding-bottom: 4px;
  border-bottom: 1px solid ${colors.black};

  &:hover {
    color :${colors.green};
    border-color: ${colors.green};
  }
`

export {
  ButtonStyleWhite,
  ButtonStyleBeige,
  ButtonStyleBeigeBorder,
  ButtonStyleGreen,
  ButtonStyleDarkGreen,
  ButtonStyleGreenDisabled,
  ButtonStyleLightGreen,
  ButtonStyleTransparent,
  TextLinkStyle,
}
